import { render, staticRenderFns } from "./IncentiveClaim.vue?vue&type=template&id=c9bfce70&"
import script from "./IncentiveClaim.vue?vue&type=script&lang=js&"
export * from "./IncentiveClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports